import styled from 'styled-components'

const Wrapper = styled.article`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: ${({ theme }) => theme.spacing[8]}
    ${({ theme }) => theme.spacing[32]};
  margin-bottom: ${({ theme }) => theme.spacing[48]};
`

export default Wrapper
